import PrivateRoute from "../../components/PrivateRoute";

// Páginas de Usuários
import CreateUserPage from "../../pages/users/user/CreateUserPage";
import EditUserPage from "../../pages/users/user/EditUserPage";
import PerfilUserPage from "../../pages/users/user/PerfilUserPage";
import UsersPage from "../../pages/users/user/UsersPage";
import UserOrganizationsPage from "../../pages/users/user/organizations/UserOrganizationsPage";

// Páginas de Organizações
import CreateOrganizationPage from "../../pages/organization/CreateOrganizationPage";
import EditOrganizationPage from "../../pages/organization/EditOrganizationPage";
import OrganizationPage from "../../pages/organization/OrganizationPage";

// Páginas de Funções (Roles)
import CreateRolePage from "../../pages/roles/CreateRolePage";
import EditRolePage from "../../pages/roles/EditRolePage";
import RolePage from "../../pages/roles/RolesPage";

// Páginas de Organizações - Detalhes e Localizações
import OrganizationDetailsPage from "../../pages/organization/OrganizationDetailsPage";
import CreateOrganizationAddressPage from "../../pages/organization/address/CreateOrganizationAddressPage";
import EditOrganizationAddressPage from "../../pages/organization/address/EditOrganizationAddressPage";
import OrganizationAddressDetailsPage from "../../pages/organization/address/OrganizationAddressDetailsPage";
import CreateOrganizationLocationPage from "../../pages/organization/locations/CreateOrganizationLocationPage";
import DetailsOrganizationLocationPage from "../../pages/organization/locations/DetailsOrganizationLocationPage";
import EditOrganizationLocationPage from "../../pages/organization/locations/EditOrganizationLocationPage";
import LocationOrganizationPage from "../../pages/organization/locations/LocationOrganizationPage";
import AuditLogsPage from "../../pages/audit/AuditLogsPage";
import AuditLogReportPage from "../../pages/audit/AuditLogReportPage";

const RoutesAdmin = {
  users: [
    // * Usuários
    {
      path: "/aluguel/usuarios",
      element: <PrivateRoute element={UsersPage} />,
    },
    {
      path: "/aluguel/usuarios/criar",
      element: <PrivateRoute element={CreateUserPage} />,
    },
    {
      path: "/aluguel/usuarios/editar/:id",
      element: <PrivateRoute element={EditUserPage} />,
    },
    {
      path: "/aluguel/usuarios/perfil/:id",
      element: <PrivateRoute element={PerfilUserPage} />,
    },
    {
      path: "/aluguel/usuarios/organizacoes/:id",
      element: <PrivateRoute element={UserOrganizationsPage} />,
    },
    // TODO: Verificar se é necessário
    {
      path: "/aluguel/usuarios/:userId/aplicacoes/:applicationId/organizacoes",
      element: <PrivateRoute element={UserOrganizationsPage} />,
    },
  ],
  organizations: [
    // * Organizações
    {
      path: "/aluguel/organizacoes/dashboard",
      element: <PrivateRoute element={OrganizationPage} />,
    },
    {
      path: "/aluguel/organizacoes/criar/",
      element: <PrivateRoute element={CreateOrganizationPage} />,
    },
    {
      path: "/aluguel/organizacoes/editar/:organizationId",
      element: <PrivateRoute element={EditOrganizationPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId",
      element: <PrivateRoute element={OrganizationDetailsPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId/enderecos/adicionar",
      element: <PrivateRoute element={CreateOrganizationAddressPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId/enderecos/editar/:addressId",
      element: <PrivateRoute element={EditOrganizationAddressPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId/enderecos/detalhes/:addressId",
      element: <PrivateRoute element={OrganizationAddressDetailsPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId/enderecos/:addressId/localizacoes",
      element: <PrivateRoute element={LocationOrganizationPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId/enderecos/:addressId/localizacoes/adicionar",
      element: <PrivateRoute element={CreateOrganizationLocationPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId/enderecos/:addressId/localizacoes/editar/:locationId",
      element: <PrivateRoute element={EditOrganizationLocationPage} />,
    },
    {
      path: "/aluguel/organizacoes/detalhes/:organizationId/enderecos/:addressId/localizacoes/detalhes/:locationId",
      element: <PrivateRoute element={DetailsOrganizationLocationPage} />,
    },
  ],
  roles: [
    { path: "/aluguel/logs", element: <PrivateRoute element={AuditLogsPage} /> },
    { path: "/aluguel/relatorios/logs", element: <PrivateRoute element={AuditLogReportPage} /> },
    {
      path: "/aluguel/cargos",
      element: <PrivateRoute element={RolePage} />,
    },
    {
      path: "/aluguel/cargos/criar",
      element: <PrivateRoute element={CreateRolePage} />,
    },
    {
      path: "/aluguel/cargos/editar/:roleId",
      element: <PrivateRoute element={EditRolePage} />,
    },
  ],
};

export default RoutesAdmin;
